import { memo } from 'react';
function ExhibitPickup({ color = '#C0C0C0', size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5 9V7L10.5 0L0.5 7V9H2.5V18H0.5V20H20.5V18H18.5V9H20.5ZM16.5 18H4.5V7H16.5V18Z"
        fill={color}
      />
      <path d="M8.5 12L10.5 15L12.5 12V16H14.5V9H12.5L10.5 12L8.5 9H6.5V16H8.5V12Z" fill={color} />
    </svg>
  );
}

export default memo(ExhibitPickup);
